import Button from '@meitu/saas-ui/es/button';
import { useSvgModel } from '@/store/models/svg-model';
import { downloadSvg } from '../utils/svg-kit';
import './index.less';

const Header = () => {
    const curShape = useSvgModel((state) => state.curShape);
    return (
        <div className="design-svg-header">
            <Button type="primary" onClick={() => downloadSvg(curShape)}>
                下载
            </Button>
        </div>
    );
};
export default Header;
